<template>
    <v-container class="flex-grow-1">
        <div class="my-3 d-flex justify-left">
            <h1 class="uiTitle header">
                Berechnungsvorlagen
            </h1>
        </div>
        <div class="d-flex justify-center">
            <v-data-table
                  :headers="headers"
                  :items="vorlagen"
            >
                <template v-slot:[`body.prepend`]>
                    <tr class="berechnungsvorlagen">
                        <td>
                            <v-text-field
                                v-model="dateiId"
                                type="text"
                                label="Datei-Id"
                            ></v-text-field>
                        </td>
                        <td>
                            <v-text-field
                                v-model="dateiname"
                                type="text"
                                label="Dateiname"
                            ></v-text-field>
                        </td>
                        <td>
                            <v-text-field
                                v-model="anlagedatum"
                                type="text"
                                label="Anlagedatum"
                            ></v-text-field>
                        </td>
                        <td>
                            <v-text-field
                                v-model="anlagenutzer"
                                type="text"
                                label="Anlagenutzer"
                            ></v-text-field>
                        </td>
                        <td>
                            <v-text-field
                                v-model="kommentar"
                                type="text"
                                label="Kommentar"
                            ></v-text-field>
                        </td>
                        <td>
                            <v-text-field
                                v-model="aenderungsdatum"
                                type="text"
                                label="Änderungsdatum"
                            ></v-text-field>
                        </td>
                        <td>
                            <v-text-field
                                v-model="aenderungsnutzer"
                                type="text"
                                label="Änderungsnutzer"
                            ></v-text-field>
                        </td>
                        <td style="min-width:70px"></td>
                    </tr>
                </template>
                <template v-slot:[`item.anlagedatum`]="{ item }">
                    <span style="font-size:inherit">{{ formatDate(item.anlagedatum) }}</span>
                </template>
                <template v-slot:[`item.aenderungsdatum`]="{ item }">
                    <span style="font-size:inherit">{{ formatDate(item.aenderungsdatum) }}</span>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-icon small class="mr-2" @click="loadItem(item)">
                        mdi-arrow-up-bold
                    </v-icon>
                    <v-icon small class="mr-2" @click="editItem(item)">
                        mdi-pencil
                    </v-icon>
                    <v-dialog
                        v-model="dialogs[item.dateiId]"
                        width="500"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon small v-bind="attrs" v-on="on">
                                mdi-delete
                            </v-icon>
                        </template>
                        <v-card>
                            <v-card-title class="headline grey lighten-2">
                                Berechnungsvorlage löschen
                            </v-card-title>
                            <v-card-text v-html="$t('berechnungsvorlagen.delete', {dateiname: item.dateiname})"></v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" aria-labelled-by="Nein, zurück" text @click="$set(dialogs, item.dateiId, false)">
                                    Nein, zurück
                                </v-btn>
                                <v-btn aria-labelled-by="Ja, löschen" @click="acceptDelete(item)">
                                    Ja, löschen
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </template>
            </v-data-table>
        </div>
    </v-container>
</template>

<script>
    import {Component, Vue} from 'vue-property-decorator';
    import { EventBus } from '../eventbus';
    import moment from 'moment';

    @Component
    export default class Berechnungsvorlagen extends Vue {

        setResult(ergebnis) {
            this.$store.dispatch('ergebnis/SET_ERGEBNIS', { ergebnis: ergebnis })
        }

        setCalculation(berechnung) {
            this.$store.dispatch('berechnung/SET_BERECHNUNG', { berechnung: berechnung })
        }

        setPdfParams(pdfParameters) {
            this.$store.dispatch('pdfparams/SET_PDFPARAMS', { stichtagsdifferenz: pdfParameters.stichtagsdifferenz, zusaetzlicheBegruendungen: pdfParameters.zusaetzlicheBegruendungen })
        }

        setErrors(errors) {
            this.$store.dispatch('error/SET_ERRORS', { errors: errors })
        }

        showMessage(message){
            this.$store.dispatch('snackbar/showMessage', { message: message })
        }

        data() {
            return {
                search: '',
                dateiId: '',
                dateiname: '',
                anlagedatum: '',
                anlagenutzer: '',
                kommentar: '',
                aenderungsdatum: '',
                aenderungsnutzer: '',
                dialogs: {},
                headers: [
                          {
                            text: 'Datei-Id',
                            align: 'start',
                            sortable: true,
                            value: 'dateiId',
                            filter: value => {
                                if (!this.dateiId) return true
                                if (!value) return false
                                return value.toString().includes(this.dateiId)
                            },
                          },
                          { text: 'Dateiname', value: 'dateiname', filter: value => {
                                                                                 if (!this.dateiname) return true
                                                                                if (!value) return false
                                                                                 return value.toLowerCase().includes(this.dateiname.toLowerCase())
                                                                               }, },
                          { text: 'Anlagedatum',
                            value: 'anlagedatum',
                            filter: value => {
                              if (!this.anlagedatum) return true
                              if (!value) return false
                              return this.formatDate(value).toString().includes(this.anlagedatum.toLowerCase())
                            },  }, //formatDate
                          { text: 'Anlagenutzer', value: 'anlagenutzer', filter: value => {
                                                                                if (!this.anlagenutzer) return true
                                                                                if (!value) return false
                                                                                return value.toLowerCase().includes(this.anlagenutzer.toLowerCase())
                                                                              },  },
                          { text: 'Kommentar', value: 'kommentar', filter: value => {
                                                                                if (!this.kommentar) return true
                                                                                if (!value) return false
                                                                                return value.toLowerCase().includes(this.kommentar.toLowerCase())
                                                                              },  },
                          { text: 'Änderungsdatum',
                            value: 'aenderungsdatum',
                            filter: value => {
                                                if (!this.aenderungsdatum) return true
                                                if (!value) return false
                                                return this.formatDate(value).toString().includes(this.aenderungsdatum.toLowerCase())
                                              },  },
                          { text: 'Änderungsnutzer', value: 'aenderungsnutzer', filter: value => {
                                                                                if (!this.aenderungsnutzer) return true
                                                                                if (!value) return false
                                                                                return value.toLowerCase().includes(this.aenderungsnutzer.toLowerCase())
                                                                              },  },
                          { text: 'Aktion', value: 'actions', sortable: false },
                        ],
                        vorlagen: []
                };
        }

        mounted() {
            if(!window.location.href.includes("auth")){
                console.log("redirect")
                const url = this.$root.$children[0].getBackendUrl() + `/auth/index.html#/berechnungsvorlagen`;
                window.location.replace(url)
            }
            this.getVorlagen()
        }

        getVorlagen() {
            const url = this.$root.$children[0].getBackendUrl() +
                `/api/backend-service/berechnungsvorlages`;
            return fetch(url, {
                method: 'GET',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'include',
                headers: {
                  'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer'
            }).then(res => {
                if (res.status == 404) {
                    console.error(`Error: Endpoint not found`);
                    return;
                }
                if (res.status != 200) {
                    console.error(`error while calculating result with status:`+ res.status);
                    return;
                }
                return res.json();
            }).then(json => {
                let result = json._embedded["berechnungsvorlages"]
                this.vorlagen = result
            });
        }

        loadItem(item) {
            console.log("load data", item)
            this.setCalculation(item.berechnungsdaten.pdfParameters.berechnung)
            this.setPdfParams(item.berechnungsdaten.pdfParameters)
            this.setResult(item.berechnungsdaten.ergebnis)
            //deserialize error functions - only process item to be loaded
            Object.keys(item.berechnungsdaten.errors).forEach(error => {
                if(error.startsWith('selected')){
                    //multiple-choice components (sanitaerbereich,abweichungen,elektrogeraete) need special treatment
                    if(Array.isArray(item.berechnungsdaten.errors[error])){
                        item.berechnungsdaten.errors[error].forEach(el => {
                            Object.assign(el, el.errorMap)
                            delete el.errorMap
                            this.functionsFromStringErrors(el)
                        })
                    }else{
                        this.functionsFromStringErrors(item.berechnungsdaten.errors[error])
                    }
                }
            })
            this.setErrors(item.berechnungsdaten.errors)
            EventBus.$emit('setLoadData', { loadedKommentar: item.kommentar, loadedDateiname: item.dateiname, loadedDateiid: item.dateiId })
            let savedStep = this.$root.$children[0].$data.items[item.berechnungsdaten.aktuellerSchritt].path.slice(1)
            this.$router.push(savedStep)
            this.showMessage(this.$t('berechnungsvorlagen.loadSuccess', { dateiid: item.dateiId, dateiname: item.dateiname }))
        }

        functionsFromStringErrors(selectedErrors) {
            if(selectedErrors){
                Object.keys(selectedErrors).forEach(compErr => {
                    selectedErrors[compErr] = new Function('return ' + selectedErrors[compErr])()
                })
            }
        }

        editItem(item) {
            EventBus.$emit('getEditData', { editLink: item._links.self.href, dateiname: item.dateiname, kommentar: item.kommentar })
        }

        acceptDelete(item){
            this.dialog = false
            this.deleteItem(item)
        }

        deleteItem(item) {
            const url = item._links.self.href;
                return fetch(url, {
                    method: 'DELETE',
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'include',
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    redirect: 'follow',
                    referrerPolicy: 'no-referrer'
                }).then(res => {
                    if (res.status == 404) {
                        console.error(`Error: Endpoint not found`);
                        return;
                    }
                    if (!res.ok) {
                        console.error(`error while deleting with status:`+ res.status);
                        return;
                    }
                    return res
                }).then(result => {
                    if(result){
                        this.getVorlagen()
                        this.showMessage(this.$t('berechnungsvorlagen.deleteSuccess', { dateiid: item.dateiId, dateiname: item.dateiname }))
                    }
                });
        }

        formatDate(dateString) {
            return moment(dateString).format("D.M.YYYY")
        }

    }
</script>
